import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { enhancedPointCloudIcon } from '../../../../../../shared/icons/toolbars/enhanced-point-cloud-icon';
import { RootKeyboardShortcutService } from '../../../../../../shared/keyboard-shortcuts/root-keyboard-shortcut.service';

@Component({
  selector: 'h3-enhanced-point-cloud-button',
  templateUrl: './enhanced-point-cloud-button.component.html',
  styleUrl: './enhanced-point-cloud-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EnhancedPointCloudButtonComponent {
  private readonly keyboardShortcutService = inject(
    RootKeyboardShortcutService,
  );
  tooltip =
    'Enhanced point cloud' +
    this.keyboardShortcutService.tooltipSuffix('toggleEnhancedPointCloud');
  enhancedPointCloudIcon = enhancedPointCloudIcon;
}
